module.exports = __webpack_public_path__ + "img/news_facebook_page.e8987d83.png";